"use strict";

var Collection = require('./Collection'),
    Constants = require('../constants'),
    BrochureTemplate = require('../models/BrochureTemplate'),
    data = [{
        id: 'basic',
        name: 'Standard Brochure',
        image: Constants.imageRoot + 'toolbox/PersonalizedBrochure_Preview.png'
    }];

var BrochureTemplates = Collection.extend({
    url: Constants.restPath + "/agents/brochure",
    model: BrochureTemplate,
    constructor: function(models, options) {
        models = data;
        return Collection.prototype.constructor.call(this, models, options);
    }
});

module.exports = BrochureTemplates;
